module.exports = __webpack_public_path__ + "static/img/休眠.b2c2f3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/货车/休眠.png
// module id = RLCm
// module chunks = 76